var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1884",
    "data-name": "Group 1884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1880",
    "data-name": "Group 1880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_609",
    "data-name": "Ellipse 609"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,58.76c-14.24,0-25.83-12.2-25.83-27.19S35.76,4.39,50,4.39,75.83,16.58,75.83,31.57,64.25,58.76,50,58.76Zm0-48.37c-10.94,0-19.83,9.5-19.83,21.18S39.06,52.76,50,52.76s19.83-9.5,19.83-21.19S60.94,10.39,50,10.39Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_917",
    "data-name": "Path 917"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.23,95.61a3,3,0,0,1-3-3C87.23,74,73,58.76,55.44,58.76H44.56C27,58.76,12.77,74,12.77,92.61a3,3,0,0,1-6,0c0-22,17-39.85,37.79-39.85H55.44c20.84,0,37.79,17.88,37.79,39.85A3,3,0,0,1,90.23,95.61Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.3c057bf79f09f904df084086aa2b281c.svg";
export { ForwardRef as ReactComponent };